import { Control } from 'react-hook-form';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../../../../component/form/FormTextField';
import { KsvSearchFormValues } from './useKsvSearchForm';

interface Props {
  control: Control<KsvSearchFormValues>;
  canEditAddress: boolean;
  canEditCompanyName: boolean;
  ksvSelected: boolean;
}

export function CommercialKsvSearchFields({ control, canEditAddress, canEditCompanyName, ksvSelected }: Props) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid item xs={12}>
        <FormTextField
          control={control}
          name="companyName"
          label={t('customers.edit.entryContact.companyName')}
          required
          fullWidth
          disabled={ksvSelected && !canEditCompanyName}
        />
      </Grid>
      <Grid item xs={6}>
        <FormTextField
          control={control}
          name="uidNumber"
          label={t('customers.edit.entryContact.uidNumber')}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <FormTextField
          control={control}
          name="commercialRegisterNumber"
          label={t('customers.edit.entryContact.commercialRegisterNumber')}
          fullWidth
        />
      </Grid>
      <Grid item xs={5}>
        <FormTextField
          control={control}
          name="street"
          label={t('customers.edit.entryContact.addressStreet')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={2}>
        <FormTextField
          control={control}
          name="houseNumber"
          label={t('customers.edit.entryContact.addressHouseNumber')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={2}>
        <FormTextField
          control={control}
          name="zipCode"
          label={t('customers.edit.entryContact.addressPostalCode')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={3}>
        <FormTextField
          control={control}
          name="city"
          label={t('customers.edit.entryContact.addressCity')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
    </Grid>
  );
}
